import { toast } from "react-toastify";
import { call, put, takeLatest } from "redux-saga/effects";
import api from "../../utils/api-helper/api";
import {
    acceptCustomerInviteFail,
    acceptCustomerInviteSuccess,
    acceptHeadNurseInviteFail,
    acceptHeadNurseInviteSuccess,
    addNurseByHNFail,
    addNurseByHNSuccess,
    deleteCustomerFail,
    deleteCustomerSuccess,
    editHeadNurseProfileFail,
    editHeadNurseProfileSuccess,
    editSeniorByHNFail,
    editSeniorByHNSuccess,
    getNurseByHNIdFail,
    getNurseByHNIdSuccess,
    getNursesByHNFail,
    getNursesByHNSuccess,
    getSeniorsByHNFail,
    getSeniorsByHNSuccess,
    inviteCustomerFail,
    inviteCustomerSuccess,
    invitedCustomerDataFail,
    invitedCustomerDataSuccess,
    inviteHeadNurseFail,
    inviteHeadNurseSuccess,
} from "../actions/headNurse";
import {
    ACCEPT_CUSTOMER_INVITE_REQUEST,
    ACCEPT_HEAD_NURSE_INVITE_REQUEST,
    AcceptCustomerInviteRequestAction,
    AcceptHeadNurseInviteRequestAction,
    ADD_NURSE_BY_HN_REQUEST,
    AddNurseRequestAction,
    DELETE_CUSTOMER_REQUEST,
    DeleteCustomerRequestAction,
    EDIT_HEAD_NURSE_PROFILE_REQUEST,
    EDIT_SENIOR_BY_HN_REQUEST,
    EditHeadNurseProfileRequestAction,
    EditSeniorByHNRequestAction,
    GET_NURSE_BY_HN_ID_REQUEST,
    GET_NURSES_BY_HN_REQUEST,
    GET_SENIORS_BY_HN_REQUEST,
    GetNurseByHNIdRequestAction,
    INVITE_CUSTOMER_REQUEST,
    INVITE_HEAD_NURSE_REQUEST,
    InviteCustomerRequestAction,
    INVITED_CUSTOMER_DATA_REQUEST,
    InvitedCustomerDataRequestAction,
    InviteHeadNurseRequestAction,
} from "../types";
import { getUsersSaga } from "./user";

function* inviteHeadNurseSaga(action: InviteHeadNurseRequestAction) {
    try {
        const { headNurseInvite, history } = action.payload;
        // @ts-ignore
        yield api.post("user/headnurse/invite", headNurseInvite);
        yield put(inviteHeadNurseSuccess());
        toast.success("Head Nurse invitation sent successfully", {
            position: "top-center",
            hideProgressBar: true,
            theme: "colored",
        });
        history.push("/admin/nurse");
    } catch (error: any) {
        toast.error(error?.response?.data?.message || "Head Nurse invitation failed", {
            position: "top-center",
            hideProgressBar: true,
            theme: "colored",
        });
        yield put(inviteHeadNurseFail(error));
    }
}

function* addNurseByHNSaga(action: AddNurseRequestAction) {
    try {
        const { nurseData, history } = action.payload;
        // @ts-ignore
        yield api.post("user/staff/request-invite", nurseData);
        toast.success("Invitation sent successfully", {
            position: "top-center",
            hideProgressBar: true,
            theme: "colored",
        });
        yield put(addNurseByHNSuccess());
        history.push("/admin/nurse");
    } catch (error: any) {
        toast.error(error?.response?.data?.message || " Nurse invitation failed", {
            position: "top-center",
            hideProgressBar: true,
            theme: "colored",
        });
        yield put(addNurseByHNFail(error));
    }
}

function* acceptHeadNurseInviteSaga(action: AcceptHeadNurseInviteRequestAction) {
    try {
        const data = action.payload;
        // @ts-ignore
        yield api.post("user/headnurse/add", data);
        // toast.success("  Successfully added as Nurse", {
        //     position: "top-center",
        //     hideProgressBar: true,
        //     theme: "colored",
        // });
        yield put(acceptHeadNurseInviteSuccess());
    } catch (error: any) {
        toast.error(error?.response?.data?.message || "Registration failed", {
            position: "top-center",
            hideProgressBar: true,
            theme: "colored",
        });
        yield put(acceptHeadNurseInviteFail(error));
    }
}

function* getNursesByHNSaga() {
    try {
        // @ts-ignore
        const response = yield api.get("/user/staff/listing/nurseByHeadNurse");
        yield put(getNursesByHNSuccess(response?.data?.nurses || []));
    } catch (error: any) {
        yield put(getNursesByHNFail(error.message || "Failed to fetch nurses"));
    }
}

function* inviteCustomerSaga(action: InviteCustomerRequestAction) {
    try {
        const { customerInvite, history } = action.payload;
        // @ts-ignore
        yield api.post("/user/customer/invite", customerInvite);
        toast.success("Invitation sent successfully", {
            position: "top-center",
            hideProgressBar: true,
            theme: "colored",
        });

        yield put(inviteCustomerSuccess());
        history.push("/admin/users");
    } catch (error: any) {
        toast.error(error?.response?.data?.message || "Invitation failed", {
            position: "top-center",
            hideProgressBar: true,
            theme: "colored",
        });
        yield put(inviteCustomerFail(error.response?.data || error.message || "Customer invite failed"));
    }
}

function* getNurseByHNIdSaga(action: GetNurseByHNIdRequestAction) {
    try {
        // @ts-ignore
        const response = yield api.get(`/user/nurseByHeadNurse/${action.payload.id}`);

        yield put(getNurseByHNIdSuccess(response?.data.payload || {}));
    } catch (error: any) {
        toast.error(error?.response?.data?.message || " Error getting Nurse information", {
            position: "top-center",
            hideProgressBar: true,
            theme: "colored",
        });
        yield put(getNurseByHNIdFail(error.response?.data || error.message || "Failed to fetch nurse"));
    }
}

function* getSeniorsByHNSaga() {
    try {
        // @ts-ignore
        const response = yield api.get("/user/staff/seniors-lists");
        yield put(getSeniorsByHNSuccess(response?.data?.payload?.seniors || []));
    } catch (error: any) {
        yield put(getSeniorsByHNFail(error.response?.data || error.message || "Failed to fetch seniors"));
    }
}

function* editSeniorByHNSaga(action: EditSeniorByHNRequestAction) {
    try {
        const data = action.payload;
        // @ts-ignore
        const response = yield api.post("user/senior/edit-by-headnurse", data);
        yield put(editSeniorByHNSuccess(response?.data || {}));
        toast.success("Profile updated Sucessfully ", {
            position: "top-center",
            hideProgressBar: true,
            theme: "colored",
        });
    } catch (error: any) {
        toast.error(error?.response?.data?.message || "Error Updating Senior", {
            position: "top-center",
            hideProgressBar: true,
            theme: "colored",
        });
        yield put(editSeniorByHNFail(error.response?.data || error.message || "Failed to edit senior"));
    }
}

function* acceptCustomerInviteSaga(action: AcceptCustomerInviteRequestAction) {
    try {
        const data = action.payload;
        // @ts-ignore
        yield api.post("user/customer/add", data);
        // toast.success("Registration Completed", {
        //     position: "top-center",
        //     hideProgressBar: true,
        //     theme: "colored",
        // });
        yield put(acceptCustomerInviteSuccess());
    } catch (error: any) {
        toast.error(error?.response?.data?.message || "Registration failed", {
            position: "top-center",
            hideProgressBar: true,
            theme: "colored",
        });
        yield put(acceptCustomerInviteFail(error.response?.data || error.message || "Failed to accept customer invite"));
    }
}

function* deleteCustomerSaga(action: DeleteCustomerRequestAction) {
    try {
        const id = action.payload.customerId;
        // @ts-ignore
        yield api.delete(`user/customers/${id}`);
        yield put(deleteCustomerSuccess());
        yield call(getUsersSaga);
    } catch (error: any) {
        toast.error(error?.response?.data?.message || " User deletion failed", {
            position: "top-center",
            hideProgressBar: true,
            theme: "colored",
        });
        yield put(deleteCustomerFail(error.response?.data || error.message || "Failed to accept customer invite"));
    }
}

function* editHeadNurseProfileSaga(action: EditHeadNurseProfileRequestAction) {
    try {
        const { data, history } = action.payload;
        // @ts-ignore
        const response = yield api.patch("user/staff/headNurse/edit-profile", data);
        yield put(editHeadNurseProfileSuccess(response?.data || {}));
        toast.success("Head Nurse profile updated successfully", {
            position: "top-center",
            hideProgressBar: true,
            theme: "colored",
        });
        history.push("/admin/nurse");
    } catch (error: any) {
        toast.error(error?.response?.data?.message || "Error updating Head Nurse profile", {
            position: "top-center",
            hideProgressBar: true,
            theme: "colored",
        });
        yield put(editHeadNurseProfileFail(error.response?.data || error.message || "Failed to edit Head Nurse profile"));
    }
}

function* invitedCustomerDataSaga(action: InvitedCustomerDataRequestAction) {
    try {
        // @ts-ignore
        const response = yield api.get(`/user/invitedCustomer/${action.payload}`);
        yield put(invitedCustomerDataSuccess(response?.data?.payload || {}));
    } catch (error: any) {
        yield put(invitedCustomerDataFail(error.response?.data || error.message || "Failed to fetch invited customer data"));
    }
}

const headNurseWatcher = [
    takeLatest(INVITE_HEAD_NURSE_REQUEST, inviteHeadNurseSaga),
    takeLatest(ADD_NURSE_BY_HN_REQUEST, addNurseByHNSaga),
    takeLatest(ACCEPT_HEAD_NURSE_INVITE_REQUEST, acceptHeadNurseInviteSaga),
    takeLatest(GET_NURSES_BY_HN_REQUEST, getNursesByHNSaga),
    takeLatest(GET_NURSE_BY_HN_ID_REQUEST, getNurseByHNIdSaga),
    takeLatest(GET_SENIORS_BY_HN_REQUEST, getSeniorsByHNSaga),
    takeLatest(INVITE_CUSTOMER_REQUEST, inviteCustomerSaga),
    takeLatest(EDIT_SENIOR_BY_HN_REQUEST, editSeniorByHNSaga),
    takeLatest(ACCEPT_CUSTOMER_INVITE_REQUEST, acceptCustomerInviteSaga),
    takeLatest(DELETE_CUSTOMER_REQUEST, deleteCustomerSaga),
    takeLatest(EDIT_HEAD_NURSE_PROFILE_REQUEST, editHeadNurseProfileSaga),
    takeLatest(INVITED_CUSTOMER_DATA_REQUEST, invitedCustomerDataSaga),
];
export default headNurseWatcher;
